import React from "react";

export const Inp = ({ icon: Ic, placeholder, value, onChange, style: st, type, bg, error, maxLength }) =>
  <div className="relative" style={st}>
    {Ic && <Ic size={13} className="absolute left-[10px] top-1/2 -translate-y-1/2 text-t3 pointer-events-none" />}
    <input
      type={type || "text"}
      placeholder={placeholder}
      value={value}
      maxLength={maxLength}
      onChange={e => onChange?.(e.target.value)}
      className={`w-full py-[7px] pr-[10px] ${bg || "bg-bg2"} border ${error ? "border-r" : "border-b0"} rounded-[10px] text-t0 text-[14px] outline-none ${Ic ? "pl-[32px]" : "pl-[10px]"}`}
    />
  </div>;
